import * as React from "react";
import { APIConfig, isUserLocked, login, requestCode } from "../API";
import { Loading, loading } from "../Loading";
import { CaregiverPhoneEntryScreen } from "../components/CaregiverPhoneEntryScreen";
import { Caregiver } from "../messages/Caregiver";
import { CaregiverPhoneValidationCodeEntryScreen } from "../components/CaregiverPhoneValidationCodeEntryScreen";
import { AgencyId, CaregiverCertification } from "../messages/ObjectIds";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setOfficesActionCreator } from "src/store/slices/officesSlice";
import { setAgencyCertificationsActionCreator } from "src/store/slices/certificationsSlice";
import { useEffect } from "react";
interface CaregiverPhoneEntryActivityProps {
    apiConfig: APIConfig;
    agencyId: AgencyId;
    onSuccessfulLogin: (authToken: string, caregiver: Caregiver | null, phoneNumber: string) => void;
}

const CaregiverPhoneEntryActivity = (props: CaregiverPhoneEntryActivityProps) => {
    const [showInternetError, setShowInternetError] = useState<string | null | Loading>(null);
    const [phoneNumber, setPhoneNumber] = useState<string | null>(null);
    const dispatch = useDispatch();
    let isMounted = true;

    const handlePhoneEntryClick = async (phoneNumber: string) => {
        setShowInternetError(loading());
        const resp = await requestCode(props.apiConfig, phoneNumber);
        if (!isMounted) {
            return;
        }

        setShowInternetError(resp ? null : "There seems to be something wrong with internet...");
        setPhoneNumber(phoneNumber);

    };

    const handleCodeClick = async (code: string) => {
        if (!isMounted) {
            return;
        }

        if (phoneNumber === null) {
            throw new Error("The impossible happened");
        }
        setShowInternetError(loading());
        const caregiverLoginResponse = await login(props.apiConfig, props.agencyId, phoneNumber, {
            code: code,
            isFromMobileApp: false
        });


        if (isUserLocked(caregiverLoginResponse)) {
            setShowInternetError("This user has been locked due to suspicious activity contact support for more info");
        } else if (caregiverLoginResponse === null) {
            setShowInternetError("Are you sure the code is correct?");
        } else {
            if (caregiverLoginResponse.authToken === undefined) {
                throw new Error("Auth token is undefined but why");
            }

            dispatch(setOfficesActionCreator(caregiverLoginResponse.agencyOffices));
            dispatch(setAgencyCertificationsActionCreator(caregiverLoginResponse.agencyHRCertifications));

            props.onSuccessfulLogin(
                caregiverLoginResponse.authToken,
                caregiverLoginResponse.caregiver === undefined ? null : caregiverLoginResponse.caregiver,
                phoneNumber
            );
            setShowInternetError(null);
        }
    };

    useEffect(() => {
        return () => { isMounted = false; };
    }, []);

    return (
        <div>
            {phoneNumber === null ?
                <CaregiverPhoneEntryScreen
                    showInternetError={showInternetError}
                    onPhoneNumberClick={(phoneNumber) => handlePhoneEntryClick(phoneNumber)}
                />
                :
                <CaregiverPhoneValidationCodeEntryScreen
                    onRequestCodeClick={(code) => handleCodeClick(code)}
                    showInternetError={showInternetError}
                    phoneNumber={phoneNumber}
                    onReceiveNewCodeClick={() => {
                        setPhoneNumber(null);
                        setShowInternetError(null);
                    }}
                />
            }
        </div>
    );
};

export default CaregiverPhoneEntryActivity;



// WEBPACK FOOTER //
// ./src/activities/CaregiverPhoneEntryActivity.tsx